import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/common/ui/toast'
import { useToast } from '@/components/common/ui/use-toast'
import { useAnalysisProgressSafe } from '@/hooks/useAnalysisProgress'

export function Toaster() {
  const { toasts } = useToast()
  const analysisProgress = useAnalysisProgressSafe()

  // Filter toasts based on batch execution state
  const filteredToasts = toasts.filter(toast => {
    if (!analysisProgress?.state?.isVisible || !analysisProgress?.state?.activeBatchId) {
      return true
    }

    return toast.category !== 'batch'
  })

  return (
    <ToastProvider>
      {filteredToasts.map(({ id, title, description, action, ...props }) => {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      {/*
        下端のフローティング要素（画面フッター・実行状況カード）を**実測値で避ける**。

        ⚠️ 以前は「動いている機能の数」から `bottom-28` / `bottom-44` を選んでいたが、
        これは実行状況カードの高さを**トースト側が推測し直す**作りで、次の2つで破綻した。
        ① カードに検知の行が増えても条件に入っておらず、高さが変わったのに避ける量が変わらない
        ② カードが画面フッターぶん持ち上がる画面（検知実行）では、そのぶんを知らないので重なる
        カード自身が高さを CSS 変数で知らせ、ここはそれを足すだけにする（行が増えても追随する）。
        変数が無い画面では 0 に落ちるので、カードが出ていないときは従来どおり下端に寄る。

        ※ カードとの間隔は viewport の `pb-6`（24px）が作る。
      */}
      <ToastViewport
        className="fixed right-4 sm:right-4 z-[100] flex max-h-screen w-full flex-col p-4 pb-6 md:max-w-[320px]"
        style={{
          bottom:
            'calc(1rem + var(--app-bottom-bar-height, 0px) + var(--app-progress-indicator-height, 0px))',
        }}
      />
    </ToastProvider>
  )
}
